const Index = () => (
  <div className="flex flex-col items-center justify-center min-h-screen w-full">
    <h1 className="text-xl md:text-3xl font-medium text-primary text-center">
      Something amazing starts here...
    </h1>
    <p className="text-sm text-primary/40 text-center mt-6">
      This is a SteerCode starting template.<br />Ask AI to make any changes.
    </p>
  </div>
);

export default Index;
